module.exports = __webpack_public_path__ + "img/fanhui1.14c045a3.svg";